import { BodyLargeRegular, Icon, type IconType, View, XStack } from 'smoothie';

interface PreviewSectionHeaderProps {
    icon: IconType;
    title: string;
    rotate?: boolean;
}

const PreviewSectionHeader = ({
    icon,
    title,
    rotate,
}: PreviewSectionHeaderProps) => {
    return (
        <XStack alignItems="center" gap={8} paddingBottom={8}>
            <View rotate={rotate ? '180deg' : undefined}>
                <Icon icon={icon} color="$black" />
            </View>

            <BodyLargeRegular>{title}</BodyLargeRegular>
        </XStack>
    );
};

export default PreviewSectionHeader;
